module.exports = __webpack_public_path__ + "img/banner-font.a0753060.png";